<div>
  <div class="headers">
    <div class="page-title">Deeproots</div>
  </div>

  <div class="tabs-container">
    <div class="tabs">
      @for (tab of tabs; track tab.id) {
        <button
          class="tab"
          [class.active]="activeTab === tab.id"
          (click)="onTabChange(tab.id)"
        >
          {{ tab.label }}
        </button>
      }
    </div>
  </div>

  <div class="tab-content">
    @if (activeTab === "links") {
      <app-deeproots-links></app-deeproots-links>
    } @else if (activeTab === "feedback") {
      <app-deeproots-feedback></app-deeproots-feedback>
    }
  </div>
</div>
